import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import serviceRevisaoCotaUsina from "../../../../services/serviceRevisaoCotaUsina";
import messages from "../../../../utils/messages";
import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import AutoComplete from "@/components/hookForms/autoComplete";
import IGenericResult from "../../../../interfaces/IGenericResult";
import * as S from "../../../../theme/globalStyles";

export interface IDialogProps {
    data: any;
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogTransfer({ open, onClose, data, onSuccess }: IDialogProps) {
    const [instalacaoDataOptions, setInstalacaoDataOptions] = useState<IGenericResult[]>([]);
    const [isDisable, setDisable] = useState(false);

    const holder = [{ label: "", value: "" }];

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            instalacaoID: "",
        },
    });

    const onSubmit = (values: any) => {
        setDisable(true);

        const treatedValues = {
            revisaoCotaUsinaId: data.id,
            idsInstalacaoOrigem: values.instalacaoOrigemID ? values.instalacaoOrigemID.join(", ") : "",
            idInstalacaoDestino: values.instalacaoDestinoID.toString(),
        };

        serviceRevisaoCotaUsina
            .transfer(treatedValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.createSucess);
                }
                onClose(true);
                reset();
                onSuccess();
            })
            .finally(() => {
                setDisable(false);
                onClose(true);
                reset();
            });
    };

    useEffect(() => {
        if (data && data.id) {
            getInstalacaoData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const getInstalacaoData = async () => {
        serviceRevisaoCotaUsina
            .getInstalacoesByRevisaoCotaUsina(data.id)
            .then((result) => {
                setInstalacaoDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacaoDataOptions([]);
            });
    };

    const onCancelNew = () => {
        setInstalacaoDataOptions([]);
        reset();
        onClose(true);
    };

    return (
        <Dialog
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Transferência de revisão de cota instalação
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelNew();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <S.Subtitles>Usina: {data.info}</S.Subtitles>
                    <S.Subtitles>Origem</S.Subtitles>
                    <Grid container spacing={3} display="flex" alignItems="center">
                        <Grid item xs={12} md={12}>
                            <AutoCompleteMult
                                name="instalacaoOrigemID"
                                label="Instalação"
                                options={instalacaoDataOptions ? instalacaoDataOptions : holder}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                    <S.Subtitles>Destino</S.Subtitles>
                    <Grid container spacing={3} display="flex" alignItems="center">
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                name="instalacaoDestinoID"
                                label="Instalação"
                                options={instalacaoDataOptions ? instalacaoDataOptions : holder}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        onClick={() => {
                            onCancelNew();
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
